import { render, staticRenderFns } from "./VacationsRejectedDayLegend.vue?vue&type=template&id=d61fbede&"
import script from "./VacationsRejectedDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationsRejectedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d61fbede')) {
      api.createRecord('d61fbede', component.options)
    } else {
      api.reload('d61fbede', component.options)
    }
    module.hot.accept("./VacationsRejectedDayLegend.vue?vue&type=template&id=d61fbede&", function () {
      api.rerender('d61fbede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/VacationsRejectedDayLegend.vue"
export default component.exports